import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal } from 'react-bootstrap';
import './style.css';
const ModalPopup = ({ title, content, onOpen, onClose, modalWidth }) => {
    return (_jsxs(Modal, { show: onOpen, size: modalWidth, onHide: onClose, backdrop: 'static', scrollable: true, children: [_jsx(Modal.Header, { closeButton: true, children: _jsx(Modal.Title, { className: 'vn-Popup-Title', children: title }) }), _jsx(Modal.Body, { style: { maxHeight: 'calc(100vh - 100px)', overflowY: 'auto' }, children: content })] }));
};
export default ModalPopup;
